import React from 'react';

import PageInnerWrapper from './PageInner.styles';

function PageInner(props) {
  return <PageInnerWrapper {...props} />;
}

export default PageInner;
